import { __assign } from "tslib";
import { ATDealersLinks, ATGroupLinks } from '../footer-shared-links';
export var FooterPlantLinks = function () {
    return [
        __assign({}, ATGroupLinks),
        {
            rowHeading: 'Private customers',
            subNav: [
                {
                    url: '/plant/sell',
                    displayText: 'Sell my plant machinery',
                    routerLink: false,
                },
                {
                    url: '/plant/sell-my-plant-machinery/advertising-prices',
                    displayText: 'Advertising costs',
                    routerLink: false,
                },
                {
                    url: '/safety_and_security_centre',
                    displayText: 'Buying & selling safely online',
                    routerLink: false,
                },
                {
                    url: '/terms-and-conditions/advertising',
                    displayText: 'Terms & conditions',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Quick search',
            subNav: [
                {
                    url: '/plant/plant-machinery/browse-all-makes',
                    displayText: 'All plant machinery makes',
                    routerLink: false,
                },
                {
                    url: '/plant/content',
                    displayText: 'Plant reviews',
                    routerLink: false,
                },
                {
                    url: '/plant/dealer-directory',
                    displayText: 'Plant dealers',
                    routerLink: false,
                },
            ],
        },
        __assign({}, ATDealersLinks),
    ];
};
export default FooterPlantLinks;
